<!--分页列表组件-->
<template>
    <div class="paginierungBody">
        <table cellpadding="0" cellspacing="0" class="paginierungTable">
            <tr>
                <td :key="i" v-for="(item, i) in titleList">
                    <input :id="'header_'+i" type="checkbox" v-if="i == 1" class="teCheckbox" />
                    <label v-if="i == 1" :for="'header_'+i" class="checkbox_lable"></label>
                    {{ item }}
                </td>
            </tr>
            <slot> </slot>
            <!--<tr v-for="(item,index) in dataList">
				<td>{{index+1}}</td>
				<td>
					<input type="checkbox" :id="checkboxId(index)" :value="item.pkid" class="teCheckbox" /> {{item.name}}
				</td>
				<td>{{item.memo}}</td>
				<td>{{new Date(item.createTime).format('yyyy-MM-dd hh:mm:ss')}}</td>
			</tr>-->
        </table>

        <div class="paginierungBottom">
            <!--编辑-->
            <div class="paginierungBottomLeft">
                <img :src="getResourcesByName('/huanbao/jpfaGuanLi/add.png')" @click="$emit('add')" />
                <img :src="getResourcesByName('/huanbao/jpfaGuanLi/edit.png')" @click="editAndDelete('编辑')" />
                <img :src="getResourcesByName('/huanbao/jpfaGuanLi/delete.png')" @click="editAndDelete('删除')" />
            </div>
            <!--分页-->
            <div class="paginierungBottomRight">
                <div class="pages">
                    <span class="spanBlue" @click="prePage">&lsaquo;</span>
                    <span @click="gotoPage(index+1)" :key="index" v-for="(item, index) in pageNum" :style="pageStyle(item)">{{ item }}</span>
                    <span class="spanBlue" @click="nextPage">&rsaquo;</span>
                </div>
                <span class="pageNum">共{{ pageNum }}页</span>
                <div class="jump">
                    <input  type="text" v-model="specifyPage" />
                    <span>页</span>
                    <span @click="gotoPage(specifyPage-0)" class="jump_btn">跳转</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import paginierung from "@/components/module/huanbao/paginierung.vue"
export default {
    components: {
        paginierung
    },
    props: {
        dataList: {
            //当前显示数据
            type: Array,
            default: []
        },
        titleList: {
            type: Array,
            default: []
        },
        pageNum: {
            //总页数
            type: Number,
            default: 0
        },
        pageSize: {
            //每页显示个数
            type: Number,
            default: 0
        },
        currentPage: {
            //当前页
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            specifyPage: "",
            nowCurrentPage: 0
        }
    },
    created() {},
    mounted() {
        this.nowCurrentPage = this.currentPage
    },
    destroyed() {},
    computed: {
        getResourcesByName() {
            return this.$store.resourcesStore.getters.getResourcesByName
        },
        checkboxId() {
            return i => {
                return "checkbox" + i
            }
        },
        pageStyle() {
            return i => {
                if (this.nowCurrentPage == i) {
                    return {
                        color: "#139ae6"
                    }
                }
            }
        }
    },
    watch: {
        currentPage(nv){
            this.nowCurrentPage = nv
        }
    },
    methods: {
        gotoPage(index){
            if(!isNaN(index)&&index>=1&&index<=this.pageNum){
                this.nowCurrentPage = index
                this.$emit("changePage",this.nowCurrentPage)
            }
        },
        prePage() {
            //上一页
            if (this.nowCurrentPage == 1) {
                this.$dialogMethod.showMessage("没有上一页")
            } else {
                this.nowCurrentPage--
                this.$emit("changePage",this.nowCurrentPage)
            }
        },
        nextPage() {
            //下一页
            if (this.nowCurrentPage == this.pageNum) {
                this.$dialogMethod.showMessage("目前为最后一页")
            } else {
                this.nowCurrentPage++
                this.$emit("changePage",this.nowCurrentPage)
            }
        },
        editAndDelete(type) {
            let seletItem = []
            this.dataList.forEach((item, i) => {
                let id = document.getElementById("checkbox" + i)
                if (id.checked) {
                    this.dataList.forEach(item2 => {
                        if (parseInt(id.value) == item2.pkid) {
                            seletItem.push(item)
                        }
                    })
                }
            })
            if (!isempty(seletItem) && seletItem.length == 1) {
                if (type == "编辑") {
                    this.$emit("edit", seletItem[0])
                } else {
                    this.$emit("delete", seletItem[0])
                }
            } else {
                this.$dialogMethod.showMessage("没有选中的项或者选择了多余项")
            }
        }
    }
}
</script>

<style scoped>
.spanBlue {
    color: #139ae6;
}

.paginierungBody {
    width: 100%;
    height: 100%;
	overflow-y: auto;
    margin: 0 auto;
}

.paginierungTable {
    width: 100%;
}

.paginierungTable tr td {
    text-align: center;
    font-size: 0.15rem;
    padding: 0.1rem 0;
}

.paginierungTable tr:nth-child(odd) td {
    background-color: #f0f0f0;
}

.paginierungTable tr:nth-child(1) td {
    background-color: #dcecf2;
    color: #139ae6;
    font-weight: 600;
	text-align: center;
}
/*表格样式*/

.paginierungBody .paginierungTable tr td:nth-child(1) {
    text-align: center;
    width: 10%;
}
.paginierungBottom {
    width: 100%;
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.paginierungBottomLeft {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 100%;
}

.paginierungBottomLeft img {
    width: 0.6rem;
	margin-right: 0.08rem;
}

.paginierungBottomRight {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.paginierungBottomRight .pages span {
	display: inline-block;
    background-color: #f0f0f0;
    padding: 0 0.15rem;
	height: 0.3rem;
	line-height: 0.3rem;
    font-size: 0.15rem;
    border: 0.01rem solid #cacaca;
}

.pageNum {
    color: #999999;
    padding-left: 0.1rem;
}

.jump {
	display: flex;
	align-items: center;
    padding-left: 0.1rem;
}

.jump input {
    width: 0.14rem;
    background-color: #f0f0f0;
    border-radius: 0;
}

.jump span {
	display: inline-block;
	height: 0.3rem;
	line-height: 0.3rem;
    background-color: #f0f0f0;
    font-size: 0.15rem;
    border: 0.01rem solid #cacaca;
    padding: 0rem 0.05rem;
}
.jump .jump_btn{
	display: inline-block;
	padding: 0 0.14rem;
	white-space: nowrap;
	margin-left: 0.1rem;
}
.moitoringTable_checkBox {
    position: relative;
}
.teCheckbox {
    position: relative;
    display: none;
}
.checkbox_lable {
    display: inline-block;
    margin-right: 0.04rem;
    width: 0.16rem;
    height: 0.16rem;
    cursor: pointer;
    border-radius: 0.04rem;
    top: 0;
    left: 0;
    border: 2px solid rgb(103, 103, 103);
}
.checkbox_lable::before {
    content: "\2714";
    width: 100%;
    display: inline-block;
    text-align: center;
    font-size: 16px;
	font-weight: 500;
    color: rgb(103, 103, 103);
    visibility: hidden;
}
.teCheckbox:checked + .checkbox_lable::before {
    visibility: visible;
}
</style>
